// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
/* eslint-disable import/no-anonymous-default-export */
import savingCollectionTypes from './saving-collection.types';
import { docodeHexResponse } from '../../../_common/common.utils';
const INITIAL_STATE = {
	getSearchMemberSavingDetailsResponse: null,
	getSearchMemberSavingDetailsArr: [],
	getParticularAccountInfoResponse: null,
	getParticularAccountInfoArr: [],
	addSavingMemberSavingDetailsResponse: null,
	getMemberSavingDetailsResponse: null,
	getMemberSavingDetailsArr: [],
};

export default (state = INITIAL_STATE, action: { type: any; payload: any }) => {
	switch (action.type) {
		/***************** GET SEARCH MEMBER SAVING DETAILS START ***********************/
		case savingCollectionTypes.GET_SEARCH_MEMBER_SAVING_DETAILS_SUCCESS:
			return {
				...state,
				getSearchMemberSavingDetailsResponse: action.payload,
				getSearchMemberSavingDetailsArr: docodeHexResponse(
					action.payload,
					'FetchMemberSavingsDetailKey',
				),
			};

		case savingCollectionTypes.GET_SEARCH_MEMBER_SAVING_DETAILS_FAILURE:
			return { ...state, getSearchMemberSavingDetailsResponse: action.payload };

		case savingCollectionTypes.GET_SEARCH_MEMBER_SAVING_DETAILS_RESPONSE_CHANGED:
			return { ...state, getSearchMemberSavingDetailsResponse: null };
		/***************** GET SEARCH MEMBER SAVING DETAILS END ***********************/

		/***************** FETCH MEMBER SAVING DETAILS START ***********************/
		case savingCollectionTypes.FETCH_MEMBER_SAVING_DETAILS_SUCCESS:
			return {
				...state,
				getMemberSavingDetailsResponse: action.payload,
				getMemberSavingDetailsArr: docodeHexResponse(
					action.payload,
					'GetMemberSavingsDetailKey',
				),
			};

		case savingCollectionTypes.FETCH_MEMBER_SAVING_DETAILS_FAILURE:
			return { ...state, getMemberSavingDetailsResponse: action.payload };

		case savingCollectionTypes.FETCH_MEMBER_SAVING_DETAILS_RESPONSE_CHANGED:
			return { ...state, getMemberSavingDetailsResponse: null };
		/***************** FETCH MEMBER SAVING DETAILS END ***********************/

		/***************** GET PARTICULAR ACCOUNT INFO START ***********************/
		case savingCollectionTypes.GET_PARTICLUAR_ACCOUNT_INFO_SUCCESS:
			return {
				...state,
				getParticularAccountInfoResponse: action.payload,
				getParticularAccountInfoArr: docodeHexResponse(
					action.payload,
					'GetParticularAccountNameInfoKey',
				),
			};

		case savingCollectionTypes.GET_PARTICULAR_ACCOUNT_INFO_FAILURE:
			return { ...state, getParticularAccountInfoResponse: action.payload };

		case savingCollectionTypes.GET_PARTICULAR_ACCOUNT_INFO_RESPONSE_CHANGED:
			return { ...state, getParticularAccountInfoResponse: null };
		/***************** GET PARTICULAR ACCOUNT INFO END ***********************/

		/***************** ADD SAVING MEMBER SAVING ACCOUNT START ***********************/
		case savingCollectionTypes.ADD_SAVING_MEMBER_SAVING_ACCOUNT_SUCCESS:
			return {
				...state,
				addSavingMemberSavingDetailsResponse: action.payload,
			};

		case savingCollectionTypes.ADD_SAVING_MEMBER_SAVING_ACCOUNT_FAILURE:
			return { ...state, addSavingMemberSavingDetailsResponse: action.payload };

		case savingCollectionTypes.ADD_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_CHANGED:
			return { ...state, addSavingMemberSavingDetailsResponse: null };
		/***************** ADD SAVING MEMBER SAVING ACCOUNT END ***********************/

		/***************** DELETE SAVING MEMBER SAVING ACCOUNT START ***********************/
		case savingCollectionTypes.DELETE_SAVING_MEMBER_SAVING_ACCOUNT_SUCCESS:
			return { ...state, deleteSavingMemberSavingDetailsResponse: action.payload };

		case savingCollectionTypes.DELETE_SAVING_MEMBER_SAVING_ACCOUNT_FAILURE:
			return { ...state, deleteSavingMemberSavingDetailsResponse: action.payload };

		case savingCollectionTypes.DELETE_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_CHANGED:
			return { ...state, deleteSavingMemberSavingDetailsResponse: null };
		/***************** DELETE SAVING MEMBER SAVING ACCOUNT END ***********************/

		default:
			return state;
	}
};
